import React from 'react';
import { getCategoryColor } from 'config/ideaCategories';

export default function OverviewSlide({ sectionNumber, ideas, ideasByCategory }) {
    const avgImpact = ideas.length > 0
        ? (ideas.reduce((sum, i) => sum + i.impact, 0) / ideas.length).toFixed(1)
        : 0;

    const avgEase = ideas.length > 0
        ? (ideas.reduce((sum, i) => sum + (i.ease || (10 - i.difficulty + 1)), 0) / ideas.length).toFixed(1)
        : 0;

    const categoriesWithIdeas = ideasByCategory.filter(cat => cat.ideas.length > 0);

    return (
        <div className="h-full w-full bg-[#d6d6d6] p-8 md:p-16 overflow-y-auto relative">
            {/* Logo */}
            <div className="absolute top-8 right-8 md:top-16 md:right-16">
                <img
                    src="/images/opificioai-logo.png"
                    alt="OpificioAI"
                    className="h-6 md:h-8 w-auto opacity-60"
                />
            </div>

            <div className="max-w-6xl mx-auto">
                {/* Section Number */}
                <div className="text-[80px] md:text-[120px] font-bold text-black/10 leading-none mb-4">
                    {sectionNumber}
                </div>

                <h2 className="text-3xl md:text-5xl font-bold text-black/90 mb-12">
                    Panoramica
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
                    {/* Total Ideas */}
                    <div className="bg-white rounded-2xl p-6 shadow-sm">
                        <div className="text-5xl font-bold text-black/90 mb-2">
                            {ideas.length}
                        </div>
                        <div className="text-black/50 text-lg">
                            Idee Totali
                        </div>
                    </div>

                    {/* Average Impact */}
                    <div className="bg-white rounded-2xl p-6 shadow-sm">
                        <div className="text-5xl font-bold text-amber-500 mb-2">
                            {avgImpact}
                        </div>
                        <div className="text-black/50 text-lg">
                            Impatto Medio
                        </div>
                    </div>

                    {/* Average Ease */}
                    <div className="bg-white rounded-2xl p-6 shadow-sm">
                        <div className="text-5xl font-bold text-emerald-500 mb-2">
                            {avgEase}
                        </div>
                        <div className="text-black/50 text-lg">
                            Facilità Media
                        </div>
                    </div>
                </div>

                {/* Category Breakdown */}
                <div className="bg-white rounded-2xl p-6 shadow-sm">
                    <h3 className="text-xl font-semibold text-black/70 mb-6">
                        Distribuzione per Categoria
                    </h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                        {categoriesWithIdeas.map(cat => (
                            <div key={cat._id} className="flex items-center gap-3">
                                <div
                                    className="w-4 h-4 rounded-full flex-shrink-0"
                                    style={{ backgroundColor: getCategoryColor(cat.value) }}
                                />
                                <div>
                                    <div className="text-2xl font-bold text-black/80">
                                        {cat.value}
                                    </div>
                                    <div className="text-sm text-black/50">
                                        {cat.ideas.length || 0} Idee
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
